import { useState, useEffect } from 'react';
import { loadThemeData } from './SessionStorage';

/**
 * Custom hook to manage theme loading with loading state
 * Returns: { loading, locationName, isContactable, error }
 */
export const useThemeLoader = (location) => {
    const [loading, setLoading] = useState(true);
    const [locationName, setLocationName] = useState("");
    const [isContactable, setIsContactable] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!location) {
            setLoading(false);
            return;
        }

        setLoading(true);
        setError(null);

        loadThemeData(location)
            .then(({ theme, name, isContactable: contactable }) => {
                // Apply theme to app-root
                const appRoot = document.getElementById("app-root");
                if (appRoot) {
                    appRoot.classList.add(theme);
                }
                setLocationName(name);
                setIsContactable(contactable !== false);
                setLoading(false);
            })
            .catch((err) => {
                console.error("Theme loading error:", err);
                setError(err.message);
                setLoading(false);
            });
    }, [location]);

    return { loading, locationName, isContactable, error };
};
